/**
 * LibrarySectionList - ライブラリ系画面で共通のセクション一覧
 *
 * /music と /music/downloaded で同じ見た目のリストを使う。
 * path を持たないセクションは未実装として非活性で表示する。
 */

import { ChevronRight, LucideIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

import { ACCENT_COLOR } from './constants'

export type LibrarySection = {
  key: string
  label: string
  Icon: LucideIcon
  /** 遷移先。未実装のセクションは未指定 */
  path?: string
}

type Props = {
  sections: LibrarySection[]
  /** スクリーンリーダー向けのリスト名 */
  ariaLabel: string
}

export const LibrarySectionList = ({ sections, ariaLabel }: Props) => {
  const navigate = useNavigate()

  return (
    <nav aria-label={ariaLabel} className="flex-1 overflow-y-auto">
      <ul className="px-4">
        {sections.map(({ key, label, Icon, path }) => (
          <li key={key}>
            <button
              type="button"
              disabled={!path}
              onClick={() => path && navigate(path)}
              className="flex w-full items-center gap-4 border-none text-left active:opacity-60 disabled:opacity-40"
            >
              <Icon size={26} color={ACCENT_COLOR} className="shrink-0" />
              <span className="flex flex-1 items-center justify-between gap-4 border-b border-white/10 py-4">
                <span className="text-xl">{label}</span>
                <ChevronRight size={20} className="shrink-0 text-muted-foreground" />
              </span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )
}
